"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Parser_1 = require("../Parser");

var parserSupport_1 = require("../parserSupport");
/**
 * Parses ProductEAN from string or number
 *
 * @author Jaroslav Sevcik
 */


var EANParser =
/*#__PURE__*/
function (_Parser_1$Parser) {
  _inherits(EANParser, _Parser_1$Parser);

  function EANParser() {
    _classCallCheck(this, EANParser);

    return _possibleConstructorReturn(this, _getPrototypeOf(EANParser).apply(this, arguments));
  }

  _createClass(EANParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (typeof input !== 'string' && typeof input !== 'number') {
        return parserSupport_1.badType(input, 'string, number');
      }

      var ean = {
        value: '',
        dateFrom: null,
        dateTo: null,
        active: null,
        eanDescription: null
      };

      if (typeof input === 'string') {
        ean.value = input;
      } else {
        ean.value = '' + input;
      }

      return parserSupport_1.succ(ean);
    }
  }]);

  return EANParser;
}(Parser_1.Parser);

exports.EANParser = EANParser;